import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import MeserosData from '../../Components/Admin/MeserosData/MeserosData';

export default function MeserosPage() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <MeserosData />
                </div>
            </section>
        </div>
    );
}
